/**
 * 분석 > 통계 타입의 페이지에서 사용하는 공통 스토어
 */
import {createData, createDynamicColumnsInfo, createDisplayTime} from '~/pages/analysis/traffic/config/trafficStatisticsChartConfig'

const inOutBound = 'inOutBound'
const inOutput = 'inOutput'
const protocol = 'protocol'
const service = 'service'
const domain = 'domain'
const qos = 'qos'

export const state = () => ({
  inOutBoundList: [],
  inOutputList: [],
  protocolList: [],
  serviceList: [],
  protocolColumns: [],
  serviceColumns: [],
  domainList: [],
  domainColumns: [],
  qosList: [],
  qosColumns: [],
  protectDomainList: []
})

export const mutations = {
  setList (state, {type, resultList, dateValue}) {
    const list = resultList
    if (type === inOutBound) {
      createDisplayTime(list, dateValue)
      state.inOutBoundList = list
    } else if (type === inOutput) {
      createDisplayTime(list, dateValue)
      state.inOutputList = list
    } else if (type === protocol) {
      state.protocolColumns = createDynamicColumnsInfo(list)
      createDisplayTime(list, dateValue)
      state.protocolList = list
    } else if (type === service) {
      state.serviceColumns = createDynamicColumnsInfo(list)
      createDisplayTime(list, dateValue)
      state.serviceList = list
    } else if (type === domain) {
      state.domainColumns = createDynamicColumnsInfo(list)
      createDisplayTime(list, dateValue)
      state.domainList = list
    } else if (type === qos) {
      state.qosList = list
    }
  },
  setProtectDomainList (state, list) {
    state.protectDomainList = list
  },
  removeTrafficList (state, type) {
    if (type === inOutBound) {
      state.inOutBoundList = []
    } else if (type === inOutput) {
      state.inOutputList = []
    } else if (type === protocol) {
      state.protocolList = []
      state.protocolColumns = []
    } else if (type === service) {
      state.serviceList = []
      state.serviceColumns = []
    } else if (type === domain) {
      state.domainList = []
      state.domainColumns = []
      state.protectDomainList = []
    } else if (type === qos) {
      state.qosList = []
    }
  },
  removeAllTrafficList (state) {
    state.inOutBoundList = []
    state.inOutputList = []
    state.protocolList = []
    state.serviceList = []
    state.protocolColumns = []
    state.serviceColumns = []
    state.domainList = []
    state.domainColumns = []
    state.qosList = []
    state.qosColumns = []
    state.protectDomainList = []
  }
}
export const actions = {
  async postAnalysisStart ({commit, dispatch}, {type, params, dateValue}) {
    const res = {
      code: 'ok'
    }
    try {
      const {code, result} = await this.$axios.$post('/api/an/analysis/start', params, {
        loading: false, successAlert: false
      })
      if (code === 'ok') {
        result.requestId = result.request_id
        result.dateValue = dateValue
        result.type = type
        res.result = result
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  async getAnalysisStatus ({commit, dispatch}, {type, requestId, dateValue}) {
    const res = {
      code: 'ok'
    }
    try {
      const {code, result} = await this.$axios.$get(`/api/an/analysis/${requestId}/status`, {
        loading: false, successAlert: false
      })
      if (code === 'ok') {
        result.type = type
        result.requestId = requestId
        result.dateValue = dateValue
        res.result = result
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  async getAnalysisResult ({commit, dispatch}, {type, requestId, dateValue}) {
    const res = {
      code: 'ok'
    }
    try {
      const {code, result} = await this.$axios.$get(`/api/an/analysis/${requestId}/result`, {
        loading: false, successAlert: false
      })
      if (code === 'ok') {
        let resultList = []
        if (type === protocol || type === service || type === domain) {
          resultList = createData(_.cloneDeep(result.result))
        } else {
          resultList = _.cloneDeep(result.result)
        }
        commit('setList', {type, resultList, dateValue})
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  async stopAnalysis ({commit}, {requestId}) {
    const res = {
      code: 'ok'
    }
    try {
      const {code, result} = await this.$axios.$delete(`/api/an/analysis/${requestId}/stop`, {
        loading: false, successAlert: false
      })
      if (code === 'ok') {
        res.result = result
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  async deleteAnalysisEnd ({commit}, {requestId}) {
    const res = {
      code: 'ok'
    }
    try {
      const {code, result} = await this.$axios.$delete(`/api/an/analysis/${requestId}/end`, {
        loading: false, successAlert: false
      })
      if (code === 'ok') {
        res.result = result
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
  },
  async getInterfaceOptions ({commit}, {deviceId}) {
    const res = {
      code: 'ok'
    }
    try {
      const {code, result} = await this.$axios.$get(`/api/an/ips/interfaces/${deviceId}`, {
        loading: false, successAlert: false
      })
      if (code !== 'ok') {
        res.code = 'nok'
        res.reason = result.msg
        return res
      }
      const list = []
      if (result && result.length > 0) {
        _.forEach(result, resultItem => {
          if (resultItem.if_info.length === 0) return
          _.forEach(resultItem.if_info, ifInfoItem => {
            const tempItem = {
              if_name: ifInfoItem.if_name,
              autonego: ifInfoItem.autonego,
              duplex: ifInfoItem.duplex,
              if_id: ifInfoItem.if_id,
              if_status: ifInfoItem.if_status,
              link_status: ifInfoItem.link_status,
              mtu: ifInfoItem.mtu,
              speed: ifInfoItem.speed
            }
            list.push(tempItem)
          })
        })
      }
      res.result = list
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  async getProtectDomainGroups () {
    const res = {
      code: 'ok'
    }
    try {
      const url = '/api/po/protection-domain/groups'
      const {code, result} = await this.$axios.$get(url, {
        loading: false, successAlert: false
      })
      if (code === 'ok') {
        res.result = result
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  async getProtectDomainPolicies ({commit}, {deviceId}) {
    const res = {
      code: 'ok'
    }
    try {
      const url = `/api/an/ips/pdomain/${deviceId}`
      const {code, result} = await this.$axios.$get(url, {
        loading: false, successAlert: false
      })

      if (code === 'ok') {
        res.result = result
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  async trafficAnalysisStart ({commit, dispatch}, {params}) {
    const res = {
      code: 'ok'
    }
    try {
      const {code, result} = await this.$axios.$post('/api/an/analysis/start', params, {
        loading: false, successAlert: false
      })
      if (code === 'ok') {
        res.result = result
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  async trafficAnalysisStatus ({commit}, {requestId}) {
    const res = {
      code: 'ok'
    }
    try {
      const {code, result} = await this.$axios.$get(`/api/an/analysis/${requestId}/status`, {
        loading: false, successAlert: false
      })
      if (code === 'ok') {
        res.result = result
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  async trafficAnalysisResult ({commit}, {requestId}) {
    const res = {
      code: 'ok'
    }
    try {
      const {code, result} = await this.$axios.$get(`/api/an/analysis/${requestId}/result`, {
        loading: false, successAlert: false
      })
      if (code === 'ok') {
        res.result = result
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  async trafficAnalysisStop ({commit}, {requestId}) {
    const res = {
      code: 'ok'
    }
    try {
      const {code, result} = await this.$axios.$delete(`/api/an/analysis/${requestId}/stop`, {
        loading: false, successAlert: false
      })
      if (code === 'ok') {
        res.result = result
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  },
  async getQosPolicyName ({commit}, {deviceId}) {
    const res = {
      code: 'ok'
    }
    try {
      const {code, result} = await this.$axios.$get(`/api/an/ips/policy/${deviceId}`, {
        loading: false, successAlert: false
      })
      if (code === 'ok') {
        res.result = result
      } else {
        res.code = 'nok'
        res.reason = result.msg
      }
    } catch (e) {
      res.code = 'nok'
      res.reason = e
    }
    return res
  }
}
export const strict = false
